module.exports = "../../../../platform/assets/pageMainIcon/youth_danjuweihulei4.svg";